<div id="accordionLocation" [formGroup]="locationForm">
  <dq-accordion id="location" icon="icon-localizacion.svg" label="Ubicacion">
    <div class="card-body px-0">
      <ul class="list-group list-group-flush">
        <li class="list-group-item">
          <div class="row">
            <div class="col-md-12">
              <span *ngIf="!editMode">
                <label for="">{{ "pos.address" | translate }} </label>
                <p>
                  {{ fullAdrress(posSelected) }}
                </p>
              </span>

              <div *ngIf="editMode">
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <label for="">{{ "pos.street" | translate }} </label>
                      <input
                        type="text"
                        class="w-90"
                        formControlName="street"
                      />
                    </p>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode && locationForm.get('street')?.errors?.required
                      "
                    >
                      {{ "validations.required" | translate }}<br
                    /></small>

                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode &&
                        locationForm.get('street')?.errors?.maxlength
                      "
                    >
                      {{
                        "validations.maxlength"
                          | translate
                            : {
                                max: locationForm.get("street")?.errors
                                  ?.maxlength.requiredLength
                              }
                      }}<br
                    /></small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <label for="">{{ "pos.city" | translate }} </label>
                      <input type="text" class="w-90" formControlName="city" />
                    </p>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode && locationForm.get('city')?.errors?.required
                      "
                    >
                      {{ "validations.required" | translate }}<br
                    /></small>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode && locationForm.get('city')?.errors?.maxlength
                      "
                    >
                      {{
                        "validations.maxlength"
                          | translate
                            : {
                                max: locationForm.get("city")?.errors?.maxlength
                                  .requiredLength
                              }
                      }}<br
                    /></small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <label for="">{{ "pos.postalCode" | translate }} </label>
                      <input
                        type="text"
                        class="w-90"
                        formControlName="postalCode"
                      />
                    </p>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode &&
                        locationForm.get('postalCode')?.errors?.required
                      "
                    >
                      {{ "validations.required" | translate }}<br
                    /></small>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode &&
                        locationForm.get('postalCode')?.errors?.maxlength
                      "
                    >
                      {{
                        "validations.maxlength"
                          | translate
                            : {
                                max: locationForm.get("postalCode")?.errors
                                  ?.maxlength.requiredLength
                              }
                      }}<br
                    /></small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <label for="">{{ "pos.state" | translate }} </label>
                      <input type="text" class="w-90" formControlName="state" />
                    </p>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode && locationForm.get('state')?.errors?.required
                      "
                    >
                      {{ "validations.required" | translate }}<br
                    /></small>

                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode && locationForm.get('state')?.errors?.maxlength
                      "
                    >
                      {{
                        "validations.maxlength"
                          | translate
                            : {
                                max: locationForm.get("state")?.errors
                                  ?.maxlength.requiredLength
                              }
                      }}<br
                    /></small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p>
                      <label for="">{{ "pos.country" | translate }} </label>
                      <input
                        type="text"
                        class="w-90"
                        formControlName="country"
                      />
                    </p>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode &&
                        locationForm.get('country')?.errors?.required
                      "
                    >
                      {{ "validations.required" | translate }}<br
                    /></small>
                    <small
                      class="form-text text-danger"
                      *ngIf="
                        editMode &&
                        locationForm.get('country')?.errors?.maxlength
                      "
                    >
                      {{
                        "validations.maxlength"
                          | translate
                            : {
                                max: locationForm.get("country")?.errors
                                  ?.maxlength.requiredLength
                              }
                      }}<br
                    /></small>
                  </div>
                </div>
                <!--<div class="row">
                  <div class="col-md-12">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-sm btn-validar px-2 d-inline"
                      ><img src="assets/img/icon-validar.svg"
                    /></a>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </li>

        <li class="list-group-item">
          <div class="row">
            <div class="col-md-12">
              <label for="">{{ "pos.geo.location" | translate }} </label>
            </div>

            <div class="col-md-6" *ngIf="!editMode">
              <p>X: {{ posSelected.lat ? posSelected.lat : "-" }}</p>
            </div>

            <div class="col-md-6" *ngIf="!editMode">
              <p>Y:{{ posSelected.lon ? posSelected.lon : "-" }}</p>
            </div>

            <div class="col-md-6" *ngIf="editMode">
              <p>
                <label for="">{{ "pos.lat" | translate }} </label>
                <input type="text" class="w-90" formControlName="lat" />
              </p>
              <small
                class="form-text text-danger"
                *ngIf="editMode && locationForm.get('lat')?.errors?.required"
              >
                {{ "validations.required" | translate }}<br
              /></small>
            </div>

            <div class="col-md-6" *ngIf="editMode">
              <p>
                <label for="">{{ "pos.lon" | translate }} </label>
                <input type="text" class="w-90" formControlName="lon" />
              </p>
              <small
                class="form-text text-danger"
                *ngIf="editMode && locationForm.get('lon')?.errors?.required"
              >
                {{ "validations.required" | translate }}<br
              /></small>
            </div>
          </div>
        </li>

        <li class="list-group-item p-0">
          <div #mapContainer id="map"></div>
        </li>
      </ul>
    </div>
  </dq-accordion>
</div>
